import React from 'react'
import PageShell from '../components/ui/PageShell'
import Card from '../components/ui/Card'
import SectionTitle from '../components/ui/SectionTitle'

export default function Impressum() {
  return (
    <PageShell>
      <SectionTitle title="Impressum" />
      <Card className="mt-4 space-y-4">
        <p className="text-sm text-white/90 font-medium">Angaben gemäß § 5 TMG</p>
        <p className="text-sm text-white/80">
          anwendungen.online
          <br />
          Marc Fischer (DJ Mac)
        </p>
        <p className="text-sm text-white/80">
          Weitere Kontakt- und Anbieterangaben findest du auf{' '}
          <a
            href="https://anwendungen.online"
            target="_blank"
            rel="noopener noreferrer"
            className="text-violet-300 hover:text-violet-200 underline"
          >
            anwendungen.online
          </a>
          .
        </p>
        <p className="text-sm text-white/60 pt-4 border-t border-white/10">
          © All rights reserved – DJ Mac (Marc Fischer). Von Musiker für Musiker.
        </p>
      </Card>
    </PageShell>
  )
}
